export default __webpack_public_path__ + "862b52c51ce56ff33ff0a9eebbef14ac.svg";